import { ImagingPanel } from './ImagingPanel';

interface ImagingRouteProps {
  patientId: string;
  clinicId: string;
}

export function ImagingRoute({ patientId, clinicId }: ImagingRouteProps) {
  return <ImagingPanel patientId={patientId} clinicId={clinicId} />;
}
